var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-b-16 bold f-s-18"},[(_vm.isCompleted)?_c('span',[_vm._v("\n    "+_vm._s(_vm.$t("numberQuestionOfQuizCompleted", {
      msg: _vm.numberOfQuizzesHavePassed,
      num: _vm.numberOfQuizzes,
    }))+"\n  ")]):_c('span',[_vm._v("\n    "+_vm._s(_vm.$t("numberQuestionOfQuiz", {
      msg: _vm.numberOfQuizzesHavePassed,
      num: _vm.numberOfQuizzes,
    }))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }